import React, { useState, useEffect, Fragment, useRef, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useHistory } from "react-router-dom"
import { showAlertAction, hideAlertAction } from "../../actions/alertActions"
import {
	getSavedBuildConceptsOnAPI,
	sendSaveToAPI,
	setCurrentFilter,
	requestLoadConceptFromAPI,
	setUnsaveFlag,
	removeConcept,
	setClearButtonBuild,
	setCurrentUUID,
	setSelectedBuildConcept,
	setBuildConceptClearAll,
	changeTermTarget,
	setTargetTerms,
} from "../../actions/buildconceptActions"
import { setCurrentSearchAction } from "../../actions/currentSearchActions"
import ModalAnzyz from "../ModalAnzyz"
import SimplePopover from "./btnInfo"
import InfoDialog from "../common/InfoDialog"
import Swal from "sweetalert2"
import ReactTagInput from "@pathofdev/react-tag-input"
import uuid from "react-uuid"
import { setAIBase } from "../../actions/multiAiBase"
import { KNOWLEDGE_BASES } from "../../utils"
import { getRetainFiltersSuccess } from "../../actions/infoActions"
import { BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS } from "../../types"
import { resetSelectedIdsAction } from "../../actions/downloadsActions"

const SearchBuild = ({
	createSearch,
	saveConceptBuilder,
	popups,
	setPopups,
	elementsFilter,
	saveElementsFilter,
	sortConcepts,
	setSortConcepts,
	filtersButton,
	filterList,
	border,
	setBorder,
	searchBuildTags,
	setSearchBuildTags,
	clearSearch,
	setClearSearch,
	setCurrentSearchTermsSelected,
	isConceptLoaded,
	setIsConceptLoaded,
	toRetainFilters,
	terms,
	conceptId,
	setConceptId,
	conceptIdInitialState,
	setPage,
	currentSearchTermsSelected,
	searchTopic,
	debouncedCallback,
	setLoadPSearchAfterPTopic,
	viewItemsBtn,
	setViewItemsBtn,
	handleReset,
}) => {
	/* ******************* REDUX STORE ******************* */
	const dispatch = useDispatch()
	const location = useLocation()
	const history = useHistory()
	const currentFilter = useSelector((state) => state.buildconcept.currentFilter)
	const updateFilterInState = (filter) => dispatch(setCurrentFilter(filter))
	const savedConceptList = useSelector((state) => state.buildconcept.user_saved_build_concepts)
	const savedConceptListShare = useSelector((state) => state.buildconcept.user_saved_build_concepts_shared)
	const savedConceptListUnshare = useSelector((state) => state.buildconcept.user_saved_build_concepts_unshared)
	const currentUUID = useSelector((state) => state.buildconcept.currentUUID)
	const loadedAPIData = useSelector((state) => state.buildconcept.loadedAPIData)
	const isUnsavedDate = useSelector((state) => state.buildconcept.unsaved_data)
	const lastestSearch = useSelector((state) => state.currentSearchs.buildConcept)
	const clearButton = useSelector((state) => state.buildconcept.clear_button)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const selectedConcept = useSelector((state) => state.buildconcept.selectedConcept)
	const currentTargetTerms = useSelector((state) => state.buildconcept.targetTerms)
	const currentIgnoreTerms = useSelector((state) => state.buildconcept.ignoreTerms)
	const currentIncludeSpecificTerms = useSelector((state) => state.buildconcept.includeSpecificTerms)
	const currentIgnoreSpecificTerms = useSelector((state) => state.buildconcept.ignoreSpecificTerms)
	const searchTerms = useSelector((state) => state.buildconcept.searchTerms)
	const selectedBase = useSelector((state) => state.multiBase.selectedBase)
	const prevSelectedId = selectedBase.prev
	const retainedFilterJobData = useSelector((state) => state.info?.retainedFilterJobData)
	const filterState = useSelector((state) => state.buildconcept.currentFilter)
	const topicBuilder = useSelector((state) => state.buildconcept.topicBuilderResults)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Component states
	const [inputSearch, updateInputSearch] = useState([])
	const [inputSaveConcept, updateInputSaveConcept] = useState("")
	const [inputLoadSearch, updateInputLoadSearch] = useState("")
	const [modalUnsavedChanges, setModalUnsavedChanges] = useState(false)
	const [modalAddingTermToSavedConcept, setModalAddingTermToSavedConcept] = useState(false)
	const [modalAddingTermToSavedConceptMessageShown, setModalAddingTermToSavedConceptMessageShown] = useState(false)
	const [modalCancelChanges, setModalCancelChanges] = useState(false)
	//Show or hide Saved Build Concept List
	const [showSavedList, setShowSavedList] = useState(false)
	// Pagination
	const [currentpageSavedConcepts, setCurrentPageSavedConcepts] = useState(1)
	const [totalpagesSavedConcepts, setTotalPagesSavedConcepts] = useState(1)
	const [currentpageSharedConcepts, setCurrentPageSharedConcepts] = useState(1)
	const [totalpagesSharedConcepts, setTotalPagesSharedConcepts] = useState(1)
	// State for manage the elements mouseOver
	const [itemId, setItemId] = useState()
	// Identifying click button
	const [buttonclick, setButtonclick] = useState("")
	// Tags input state
	const [tags, setTags] = useState([])
	// Refresh Autocomplet Element for deleting tags
	const [autoCompleteRefresh, setAutoCompleteRefresh] = useState(0)
	// Disable Search Button
	const [disabledSearchButton, setDisabledSearchButton] = useState(true)
	// Show message to remember type and press enter before search
	const [hideMessage, setHideMessage] = useState(true)
	// const conceptIdInitialState = {
	// 	current: "",
	// 	next: "",
	// }
	// const [conceptId, setConceptId] = useState(conceptIdInitialState)
	/* ******************* END REACT STATES ******************* */

	const tagInputRef = useRef(null)

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		if (tags.length > 0) {
			setDisabledSearchButton(false)
			setHideMessage(true)
		} else {
			setDisabledSearchButton(true)
			// Capture writing input
			const reactTagInput = document.getElementById("reactTagInput")
			if (reactTagInput) {
				let inputDiv = document.getElementsByClassName("react-tag-input__input")
				if (inputDiv && tags.length == 0) {
					reactTagInput.addEventListener("keyup", function (event) {
						setHideMessage(false)
					})
				}
			}
		}
	}, [tags])

	useEffect(() => {
		try {
			if (border === true && buttonclick === "search") {
				let element = document.getElementById("inputSearch")
				element.classList.add("inputBorder")
				element.focus()
			} else {
				setButtonclick("")
				let element = document.getElementById("inputSearch")
				//element.classList.remove("inputBorder");
			}

			if (border === true && buttonclick === "concept") {
				let element = document.getElementById("conceptSearch")
				element.classList.add("inputBorder")
				element.focus()
			} else {
				setButtonclick("")
				let element = document.getElementById("conceptSearch")
				element.classList.remove("inputBorder")
			}
		} catch (e) {}
	}, [border])

	useEffect(() => {
		//Refresh the save field with the current concept name
		if (clearButton === true) {
			updateInputSaveConcept("")
		} else {
			if (loadedAPIData.description) {
				updateInputSaveConcept(loadedAPIData.description)
			}
		}

		return
	}, [loadedAPIData.description])

	//Update number of elements shown in list
	useEffect(() => {
		var elements = document.getElementsByClassName("conceptLoaded")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptLoaded_page_" + currentpageSavedConcepts) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpageSavedConcepts])

	useEffect(() => {
		var elements = document.getElementsByClassName("conceptShared")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptShared_page_" + currentpageSharedConcepts) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpageSharedConcepts])

	useEffect(() => {
		if (currentFilter.share === 1) {
			document.getElementById("shareCheckbox").checked = true
		} else {
			document.getElementById("shareCheckbox").checked = false
		}
	}, [currentFilter.share])

	// Reset lastestSearch.text to empty
	useEffect(() => {
		dispatch(setCurrentSearchAction(searchBuildTags, [], "buildConcept"))
		if (clearSearch === true) {
			updateInputSaveConcept("")
		}
	}, [clearSearch])

	// Hide/Show Clear button
	useEffect(() => {
		let element = document.getElementById("clearButton")
		if (tags.length > 0) {
			element.classList.remove("disabled")
			element.classList.add("showClearButton")
		} else if (inputSaveConcept !== "") {
			element.classList.remove("disabled")
			element.classList.add("showClearButton")
		} else {
			element.classList.remove("showClearButton")
			element.classList.add("disabled")
		}
	}, [tags, inputSaveConcept])

	useEffect(() => {
		if (selectedBaseId !== prevSelectedId) {
			updateClearSearch()
			dispatch(setAIBase({ ...selectedBase, prev: selectedBaseId }))
		}
	}, [selectedBaseId])

	useEffect(() => {
		return () => {
			updateClearSearch()
			dispatch(setBuildConceptClearAll())
			setTags((prevData) => [])
		}
	}, [])

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// Update dispatch(getSavedBuildConceptsOnAPI(true)) for Load saved/shared concepts for tests
	const updateGetSavedBuildConceptsOnAPI = () => {
		//dispatch(getSavedBuildConceptsOnAPI(true));
		//saveConceptBuilder(inputSaveConcept);
	}

	// Clear function
	const updateClearSearch = (e) => {
		setCurrentSearchTermsSelected({
			target_terms: [],
			ignore_terms: [],
			soft_ignore: [],
			soft_target: [],
			search_terms: [],
		})
		setIsConceptLoaded(false)
		setClearSearch(true)
		setSearchBuildTags((prevData) => [])
		setTags((prevData) => [])
		handleReset()
		updateInputSaveConcept((prevData) => "")
		dispatch(setSelectedBuildConcept(undefined))
		setConceptId(conceptIdInitialState)
		dispatch(setClearButtonBuild(true))
		let element = document.getElementById("clearButton")
		element?.classList?.remove("showClearButton")
		element?.classList?.add("disabled")
		dispatch(setCurrentUUID(null))
		dispatch(setBuildConceptClearAll())
		// here should be a dispatch for clear search request
	}
	// Input function
	const updateSearch = (e) => {
		updateInputSearch(e.target.value)
	}
	const updateSaveConcept = (e) => {
		updateInputSaveConcept(e.target.value)
	}
	const updateLoadSearch = (e) => {
		updateInputLoadSearch(e.target.value)
	}

	let continueAfterModal = () => {
		dispatch(setUnsaveFlag(false))
		//forceSearch();
		dispatch(requestLoadConceptFromAPI(conceptId.next, true))
		setModalUnsavedChanges(false)
	}
	// Form submitted
	const updateSavedConceptSearch = () => {
		dispatch(resetSelectedIdsAction())
		let targetTags = searchBuildTags.concat(currentTargetTerms)

		if (searchBuildTags.length === 0) {
			setButtonclick("search")
			//Error, there is nothing type to search
			const alert1 = {
				msg: "Please type a term of phrase to search",
				class: "alert alert-danger",
			}
			dispatch(showAlertAction(alert1))
			return
		}
		//busco que es como un refresh
		//Que que hacer un merge ente los target tems y los de búsqueda, y ademñas, pullar los otros para que se mantengas los cambios
		dispatch(setCurrentSearchAction(searchBuildTags, [], "buildConcept"))
		setCurrentSearchTermsSelected({
			knowledgebase: KNOWLEDGE_BASES.COMBINED,
			target_terms: searchBuildTags,
			ignore_terms: currentIgnoreTerms,
			soft_ignore: currentIncludeSpecificTerms,
			soft_target: currentIgnoreSpecificTerms,
			search_terms: topicBuilder?.filter((term) => !searchTerms?.includes(term[1]))?.map((x) => x[1]),
		})
		createSearch(searchBuildTags, false, {
			knowledgebase: KNOWLEDGE_BASES.COMBINED,
			target_terms: searchBuildTags,
			ignore_terms: currentIgnoreTerms,
			soft_ignore: currentIncludeSpecificTerms,
			soft_target: currentIgnoreSpecificTerms,
			search_terms: topicBuilder?.filter((term) => !searchTerms?.includes(term[1]))?.map((x) => x[1]),
		})
	}

	const submitSearchForm = (e) => {
		dispatch(resetSelectedIdsAction())
		e.preventDefault()

		if (modalAddingTermToSavedConceptMessageShown) {
			updateSavedConceptSearch(e)
			return
		}

		// Form validation or other function.
		if (searchBuildTags.length === 0) {
			setButtonclick("search")
			//Error, there is nothing type to search
			const alert1 = {
				msg: "Please type a term of phrase to search",
				class: "alert alert-danger",
			}
			dispatch(showAlertAction(alert1))
			return
		}
		//Check if unsaved data
		if (isUnsavedDate) {
			setModalUnsavedChanges(true)
			continueAfterModal = () => {
				dispatch(setUnsaveFlag(false))
				forceSearch()
			}
			return
		}
		forceSearch()
	}

	const forceSearch = () => {
		dispatch(resetSelectedIdsAction())
		setModalUnsavedChanges(false)
		// Create Filter
		dispatch(hideAlertAction())
		dispatch(setCurrentSearchAction(searchBuildTags, [], "buildConcept"))
		setCurrentSearchTermsSelected({
			knowledgebase: KNOWLEDGE_BASES.COMBINED,
			target_terms: searchBuildTags,
			ignore_terms: [],
			soft_ignore: [],
			soft_target: [],
			search_terms: [],
		})
		createSearch(searchBuildTags)
		updateInputSaveConcept("")
	}

	const submitSaveForm = (e) => {
		dispatch(resetSelectedIdsAction())
		e.preventDefault()
		let continueSaving = true
		// for now commenting the code, will remove later
		// if (isConceptLoaded === false) {
		// 	filtered_unshare.forEach((element) => {
		// 		if (element.description === inputSaveConcept) {
		// 			if (element.shared != currentFilter.share) {
		// 				dispatch(removeConcept(element.id, false))
		// 			} else {
		// 				alert("The name entered to save the concept is currently in use. Please, choose another name to continue")
		// 				continueSaving = false
		// 			}
		// 		}
		// 	})

		// 	filtered_share.forEach((element) => {
		// 		if (element.description === inputSaveConcept) {
		// 			if (element.shared != currentFilter.share) {
		// 				dispatch(removeConcept(element.id, false))
		// 			} else {
		// 				alert("The name entered to save the concept is currently in use. Please, choose another name to continue")
		// 				continueSaving = false
		// 			}
		// 		}
		// 	})
		// }

		if (continueSaving === true) {
			// Form validation or other function.
			if (inputSaveConcept.trim() === "") {
				setButtonclick("concept")
				//Error, there is nothing type to search
				const alert1 = {
					msg: "Please type a name to save the concept",
					class: "alert alert-danger",
				}
				dispatch(showAlertAction(alert1))
				return
			}
			dispatch(hideAlertAction())
			saveConceptBuilder(inputSaveConcept, conceptId.current)
		}
	}

	// Filtering savedConceptList result
	const filtered_share = savedConceptListShare.filter((item) => {
		return item.description.toLowerCase().indexOf(inputLoadSearch.toLowerCase()) != -1
	})

	const filtered_unshare = savedConceptListUnshare.filter((item) => {
		return item.description.toLowerCase().indexOf(inputLoadSearch.toLowerCase()) != -1
	})

	//Previous Page
	const prevPageSavedConcepts = () => {
		const newCurrentPageSavedConcepts = currentpageSavedConcepts - 1
		if (newCurrentPageSavedConcepts === 0) return
		setCurrentPageSavedConcepts(newCurrentPageSavedConcepts)
	}
	const prevPageSharedConcepts = () => {
		const newCurrentPageSharedConcepts = currentpageSharedConcepts - 1
		if (newCurrentPageSharedConcepts === 0) return
		setCurrentPageSharedConcepts(newCurrentPageSharedConcepts)
	}

	// Next Page
	const nextPageSavedConcepts = () => {
		const newCurrentPageSavedConcepts = currentpageSavedConcepts + 1
		if (newCurrentPageSavedConcepts > totalpagesSavedConcepts) return
		setCurrentPageSavedConcepts(newCurrentPageSavedConcepts)
	}
	const nextPageSharedConcepts = () => {
		const newCurrentPageSharedConcepts = currentpageSharedConcepts + 1
		if (newCurrentPageSharedConcepts > totalpagesSharedConcepts) return
		setCurrentPageSharedConcepts(newCurrentPageSharedConcepts)
	}

	useEffect(() => {
		if (!_.isEmpty(retainedFilterJobData) && (currentSearchTermsSelected?.target_terms?.length > 0 || conceptId?.current)) {
			let result = []
			if (savedConceptListShare?.length > 0) result = [...result, ...savedConceptListShare]
			if (savedConceptListUnshare?.length > 0) result = [...result, ...savedConceptListUnshare]
			const item = result?.find((item) => item?.id === retainedFilterJobData?.concept_id)
			if (item && conceptId?.current) {
				loadSavedContent(item?.id, item?.description, item?.visual?.terms, item)
				setSearchBuildTags((prev) => item?.visual?.terms || [])
			} else if (currentSearchTermsSelected?.target_terms?.length > 0) {
				loadFilterRetainedData()
			}
			dispatch(getRetainFiltersSuccess())
		}
	}, [retainedFilterJobData, savedConceptListShare, savedConceptListUnshare, currentSearchTermsSelected, conceptId])

	useEffect(() => {
		if (history?.location?.state?.conceptObject && Object.keys(history?.location?.state?.conceptObject)?.length > 0) {
			const { conceptObject } = history?.location?.state
			loadSavedContent(conceptObject?.id, conceptObject?.description, conceptObject?.visual?.terms, conceptObject)
			setPage((prevPage) => 1)
			setSearchBuildTags(conceptObject?.visual?.terms || [])
			setShowSavedList(false)
			window.history.replaceState({}, document?.title)
		}
	}, [savedConceptListShare, history?.location?.state])

	const loadFilterRetainedData = () => {
		const searchItem = {
			knowledgebase: KNOWLEDGE_BASES.COMBINED,
			target_terms: currentSearchTermsSelected?.target_terms,
			ignore_terms: currentSearchTermsSelected?.ignore_terms,
			soft_ignore: currentSearchTermsSelected?.soft_ignore,
			soft_target: currentSearchTermsSelected?.soft_target,
			phrase_count: filterState.phrase_count,
			neg_phrase_count: filterState.neg_phrase_count,
			strict: true,
		}
		setTags((prevData) => currentSearchTermsSelected?.target_terms)
		searchTopic(searchItem)
	}

	useEffect(() => {
		debouncedCallback()
	}, [tags])

	const loadSavedContent = (id, description, loadTags, item) => {
		dispatch(resetSelectedIdsAction())
		setModalAddingTermToSavedConceptMessageShown(false)
		setIsConceptLoaded(true)

		if (isUnsavedDate) {
			setConceptId({ ...conceptId, next: id })
		} else {
			setConceptId({ ...conceptId, current: id })
		}

		//Check if unsaved data
		if (isUnsavedDate) {
			setModalUnsavedChanges(true)
			continueAfterModal = () => {
				dispatch(setUnsaveFlag(false))
				loadSavedContent(id, description, loadTags, item)
			}
			return
		}
		dispatch(setClearButtonBuild(false))
		dispatch(requestLoadConceptFromAPI(id, true))
		dispatch(setSelectedBuildConcept(item))
		setTags((prevData) => loadTags)
		debouncedCallback()
	}

	// LOAD CONCEPTS SORT
	function sortAZ(property) {
		return function (a, b) {
			if (a[property].toLowerCase() < b[property].toLowerCase()) {
				return -1
			} else if (a[property].toLowerCase() > b[property].toLowerCase()) {
				return 1
			} else {
				return 0
			}
		}
	}

	function sortZA(property) {
		return function (a, b) {
			if (a[property].toLowerCase() > b[property].toLowerCase()) {
				return -1
			} else if (a[property].toLowerCase() < b[property].toLowerCase()) {
				return 1
			} else {
				return 0
			}
		}
	}

	const ref = useRef(null)

	const handleClickOutside = useCallback((event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			setPopups({
				showLoadConcepts: false,
			})
			setShowSavedList(false)
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [])

	useEffect(() => {
		if (showSavedList) {
			document.addEventListener("mousedown", handleClickOutside)
		} else {
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [showSavedList])

	// Delete concept from 'Load A Saved Concept'
	const deleteConcept = (conceptId) => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then((result) => {
			if (result.isConfirmed) {
				// delete concept request
				dispatch(removeConcept(conceptId))
				if (selectedConcept?.id === conceptId) {
					//if selectedConcept and conceptId is same then clear the current view
					updateClearSearch()
				}
			}
		})
	}

	const updateCurrentTags = (newTags) => {
		let tagsList = []
		newTags.map((item) => {
			tagsList.push(item.toLowerCase())
		})
		setSearchBuildTags(tagsList)
	}

	const updateHideMessage = () => {
		setHideMessage(true)
	}

	const creation_time = (creation_time) => {
		return new Date(creation_time).toLocaleDateString("en-US", {
			year: "numeric",
			month: "long",
			day: "2-digit",
		})
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	// Get inputs results
	const { search } = inputSearch
	const { saveConcept } = inputSaveConcept
	let elementsPerPageSavedConcepts = 10
	let calcTotalPagesSavedConcepts = Math.ceil(savedConceptListUnshare.length / elementsPerPageSavedConcepts)

	let elementsPerPageSharedConcepts = 10
	let calcTotalPagesSharedConcepts = Math.ceil(savedConceptListShare.length / elementsPerPageSharedConcepts)

	if (inputLoadSearch) {
		elementsPerPageSavedConcepts = 1000
		calcTotalPagesSavedConcepts = Math.ceil(savedConceptListUnshare.length / elementsPerPageSavedConcepts)

		elementsPerPageSharedConcepts = 1000
		calcTotalPagesSharedConcepts = Math.ceil(savedConceptListShare.length / elementsPerPageSharedConcepts)
	}

	const filtersObject = { ...filtersButton, ...filterList }

	if (filtered_unshare) {
		try {
			if (sortConcepts.alphabeticalSaved === "desc") {
				filtered_unshare.sort(sortAZ("description"))
			}

			if (sortConcepts.alphabeticalSaved === "asc") {
				filtered_unshare.sort(sortZA("description"))
			}

			if (sortConcepts.dateSaved === "desc") {
				filtered_unshare.sort((a, b) => {
					let b_value = b.creation_time.$date
					if (b_value === undefined) {
						b_value = new Date(b.creation_time).getTime()
					}
					let a_value = a.creation_time.$date
					if (a_value === undefined) {
						a_value = new Date(a.creation_time).getTime()
					}
					return parseInt(b_value) - parseInt(a_value)
				})
			}

			if (sortConcepts.dateSaved === "asc") {
				filtered_unshare.sort((a, b) => {
					let b_value = b.creation_time.$date
					if (b_value === undefined) {
						b_value = new Date(b.creation_time).getTime()
					}
					let a_value = a.creation_time.$date
					if (a_value === undefined) {
						a_value = new Date(a.creation_time).getTime()
					}
					return parseInt(a_value) - parseInt(b_value)
				})
			}
		} catch (e) {}
	}

	if (filtered_share) {
		try {
			if (sortConcepts.alphabeticalShared === "desc") {
				filtered_share.sort(sortAZ("description"))
			}

			if (sortConcepts.alphabeticalShared === "asc") {
				filtered_share.sort(sortZA("description"))
			}

			if (sortConcepts.dateShared === "desc") {
				filtered_share.sort((a, b) => {
					let b_value = b.creation_time.$date
					if (b_value === undefined) {
						b_value = new Date(b.creation_time).getTime()
					}
					let a_value = a.creation_time.$date
					if (a_value === undefined) {
						a_value = new Date(a.creation_time).getTime()
					}
					return parseInt(b_value) - parseInt(a_value)
				})
			}

			if (sortConcepts.dateShared === "asc") {
				filtered_share.sort((a, b) => {
					let b_value = b.creation_time.$date
					if (b_value === undefined) {
						b_value = new Date(b.creation_time).getTime()
					}
					let a_value = a.creation_time.$date
					if (a_value === undefined) {
						a_value = new Date(a.creation_time).getTime()
					}
					return parseInt(a_value) - parseInt(b_value)
				})
			}
		} catch (e) {}
	}

	const tagChangeSearchHandler = (newTags) => {
		if (newTags !== "") {
			updateCurrentTags(newTags)
			updateHideMessage()
			dispatch(setCurrentSearchAction(newTags, [], "buildConcept"))
			//Aqui comprobamos si hay cargado un concepto para poner setUnsaveFlag a true para que guarde en el mismo concepto
			if (isConceptLoaded) {
				//here we alert if is new one of in the same
				if (!modalAddingTermToSavedConceptMessageShown) {
					setModalAddingTermToSavedConcept(true)
					setModalAddingTermToSavedConceptMessageShown(true)
				}
			}
		}
		setTags((prevData) => newTags)
		dispatch(setTargetTerms(newTags))
	}
	/* ******************* END VARIABLES ******************* */

	useEffect(() => {
		setTags((prevData) => (currentTargetTerms?.length ? currentTargetTerms : []))
		dispatch(setCurrentSearchAction(currentTargetTerms?.length ? currentTargetTerms : [], [], "buildConcept"))
		setSearchBuildTags((prev) => (currentTargetTerms?.length ? currentTargetTerms : []))
	}, [currentTargetTerms])

	return (
		<Fragment>
			<ModalAnzyz
				show={modalUnsavedChanges}
				setShow={(e) => {}}
				handleClose={(e) => {}}
				cancelBtn={(e) => {
					setModalUnsavedChanges(false)
					submitSaveForm(e)
				}}
				continueBtn={(e) => {
					continueAfterModal()
				}}
				body="There is unsaved content. Will you like to continue without saving?"
				title="Unsaved content"
				cancelTxt="Save Changes"
				continueTxt="Continue without saving"
			/>

			<ModalAnzyz
				show={modalAddingTermToSavedConcept}
				setShow={(e) => {}}
				handleClose={(e) => {}}
				cancelBtn={(e) => {
					setModalAddingTermToSavedConcept(false)
					setModalAddingTermToSavedConceptMessageShown(false)
					dispatch(setCurrentUUID(null))
					updateInputSaveConcept("")
					submitSearchForm(e)
					setIsConceptLoaded(false)
					dispatch(setSelectedBuildConcept({}))
					setConceptId(conceptIdInitialState)
				}}
				continueBtn={(e) => {
					//tengo que buscar, sin eliminar los datos del concepto actual
					updateSavedConceptSearch()
					setModalAddingTermToSavedConcept(false)
					setModalAddingTermToSavedConceptMessageShown(false)
				}}
				body="Do you want to save it in a same concept or create a new one?"
				title="Is this a new concept?"
				cancelTxt="Create a new concept"
				continueTxt="Update current concept"
			/>

			<div className="container-fluid my-3 containerSearchBuild border-bottom">
				<div className="col-md-12 ml-2 d-flex justify-content-between">
					<div id="reactTagInput" className="col-md-10 divBlock pl-2">
						<ReactTagInput
							ref={tagInputRef}
							tags={tags}
							placeholder="Type and press enter"
							maxTags={10}
							editable={true}
							readOnly={false}
							removeOnBackspace={true}
							onChange={tagChangeSearchHandler}
						/>
					</div>
					<div className=" divBlock divSearchBuild">
						<form
							className="d-flex"
							onSubmit={(e) => {
								submitSearchForm(e)
								if (viewItemsBtn === "files") {
									dispatch({
										type: BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
										payload: {
											positive: [],
											negative: [],
										},
									})
									setLoadPSearchAfterPTopic((prevData) => true)
								}
							}}
						>
							{/* <input
                id="inputSearch"
                type="text"
                name="search"
                value={inputSearch}
                onChange={updateSearch}
                className=" mb-0 col-10 px-3 searchBar"
                placeholder="Search for anything to start building a concept"
              /> */}

							<button
								data-cy="build_search_button"
								type="submit"
								className="btn btn-primary btnInputConcept"
								disabled={disabledSearchButton}
							>
								SEARCH
							</button>

							<a
								id="clearButton"
								className="btn btn-primary btnInputConcept"
								onClick={() => {
									updateClearSearch()
									const path = location?.pathname?.split("/")
									history.push(`${path?.[0]}/${path?.[1]}`)
									updateFilterInState({
										...currentFilter,
										share: 0,
									})
								}}
							>
								CLEAR ALL
							</a>
						</form>
					</div>
				</div>

				{tags.length > 0 ? null : (
					<div className="col-md-12 ml-2">
						<small style={{ marginLeft: "15px" }} hidden={hideMessage}>
							* Remember type and press enter to add a search term{" "}
						</small>
					</div>
				)}

				<div className="clear clearfix"></div>
				<div className=" ml-0 pt-20 v-top d-flex justify-content-between">
					<div className="inline-block pl-0 ml-0 v-top divConceptNameSave d-flex w-60">
						<form
							onSubmit={submitSaveForm}
							className="saveConceptForm col-12"
							//style={{ display: currentUUID === null && tags?.length === 0 ? "none" : "" }}
							style={{ display: currentTargetTerms?.length === 0 ? "none" : "" }}
						>
							<div className="col-6 divBlock" id="concept_name_to_save">
								<input
									key={autoCompleteRefresh}
									id="conceptSearch"
									type="text"
									name="saveConcept"
									className="saveConceptInput height-35"
									value={inputSaveConcept}
									onChange={updateSaveConcept}
									placeholder="Concept name to save"
								/>
							</div>

							<div className="col-2 divBlock min150" id="share_input">
								<div className="form-check inline-block">
									<input
										data-cy="checkbox_Share_Concept"
										className="form-check-input"
										type="checkbox"
										value=""
										id="shareCheckbox"
										defaultChecked={currentFilter.share}
										onClick={(e) => {
											updateFilterInState({
												...currentFilter,
												share: currentFilter.share === 1 ? 0 : 1,
											})
										}}
									/>
									<label className="form-check-label" htmlFor="shareCheckbox" style={{ marginTop: 3, marginLeft: 5 }}>
										Share concept
									</label>
								</div>
							</div>
							<div className="col-4 divBlock" id="btn_save_concept">
								<button
									data-cy="save_concept_button"
									type="submit"
									className="btn btn-outline-primary btnInputConcept height-35"
								>
									{selectedConcept?.id ? "UPDATE" : "SAVE"} CONCEPT
								</button>
							</div>
						</form>
					</div>
					<div className=" offset-md-1 inline-block pr-0 v-top d-flex" ref={ref} id="load_concept">
						<button
							data-cy="load_button"
							className="btn btn-outline-primary btn-sm height-35"
							onClick={(e) => {
								e.preventDefault()
								setShowSavedList(!showSavedList)
								setTotalPagesSavedConcepts(calcTotalPagesSavedConcepts)
								setTotalPagesSharedConcepts(calcTotalPagesSharedConcepts)
							}}
						>
							LOAD A SAVED CONCEPT
						</button>

						<div id="save_concept_loading_list" className={showSavedList ? "show" : "hide"}>
							<div className="col-12">
								<div className="col-12 d-flex mb-3">
									<form
										action="#"
										onSubmit={(e) => {
											e.preventDefault()
										}}
									>
										<input
											type="text"
											name="inputLoad"
											value={inputLoadSearch}
											onChange={updateLoadSearch}
											className="searchBarLoad px-3"
											placeholder="Filter concepts"
										/>
									</form>
								</div>

								<div className="col-12 d-flex">
									<p className="font-16">
										<strong>Your concepts</strong>
									</p>
								</div>
								<div className="col-12 d-flex mb-4 mt-3">
									<div className="col-6 divBlock d-flex justify-content-center">
										<div className="col-3 divBlock mt-1">
											<span>
												<strong>A-Z</strong>
											</span>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.alphabeticalSaved === "asc" || sortConcepts.alphabeticalSaved === ""
														? "bi bi-arrow-down-circle dateIcon"
														: "bi bi-arrow-down-circle-fill dateIcon"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														dateSaved: "",
														alphabeticalSaved: "desc",
													})
												}}
											></i>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.alphabeticalSaved === "desc" || sortConcepts.alphabeticalSaved === ""
														? "bi bi-arrow-up-circle dateIcon ml-2"
														: "bi bi-arrow-up-circle-fill dateIcon ml-2"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														dateSaved: "",
														alphabeticalSaved: "asc",
													})
												}}
											></i>
										</div>
									</div>
									<div className="col-6 divBlock d-flex justify-content-center">
										<div className="col-3 divBlock mt-1">
											<span>
												<strong>Date</strong>
											</span>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.dateSaved === "asc" || sortConcepts.dateSaved === ""
														? "bi bi-arrow-down-circle dateIcon"
														: "bi bi-arrow-down-circle-fill dateIcon"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														dateSaved: "desc",
														alphabeticalSaved: "",
													})
												}}
											></i>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.dateSaved === "desc" || sortConcepts.dateSaved === ""
														? "bi bi-arrow-up-circle dateIcon ml-2"
														: "bi bi-arrow-up-circle-fill dateIcon ml-2"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														dateSaved: "asc",
														alphabeticalSaved: "",
													})
												}}
											></i>
										</div>
									</div>
								</div>
								<div className="col-12 ">
									<ul>
										{Array.isArray(filtered_unshare)
											? filtered_unshare.map((item, i) => (
													<li
														key={i}
														className={`conceptLoaded conceptLoaded_page_${Math.ceil(
															(i + 1) / elementsPerPageSavedConcepts
														)} ${
															Math.ceil((i + 1) / elementsPerPageSavedConcepts) === currentpageSavedConcepts
																? null
																: "hidePage"
														}`}
													>
														<span
															className="pointer"
															onMouseOver={(e) => {
																e.preventDefault()
																setItemId(item.id)
															}}
															onMouseOut={(e) => {
																e.preventDefault()
																setItemId("")
															}}
															style={
																item.id === itemId
																	? {
																			borderBottom: "1px solid black",
																			fontWeight: "bold",
																	  }
																	: null
															}
															onClick={(e) => {
																e.preventDefault()
																setPage((prevPage) => 1)
																loadSavedContent(item.id, item.description, item.visual.terms, item)
																//dispatch(setSelectedBuildConcept(item))
																setSearchBuildTags(item?.visual?.terms || [])
																setShowSavedList(false)
															}}
															data-cy={"load_concept_" + item.description}
														>
															{item.description}
														</span>
														<button
															id={"delete_" + item.description}
															className="btn btn-outline-danger me-md-2 btn-sm papelera"
															type="button"
															style={{ float: "right" }}
															onMouseOver={(e) => {
																e.preventDefault()
																setItemId(item.id)
															}}
															onMouseOut={(e) => {
																e.preventDefault()
																setItemId("")
															}}
															onClick={(e) => {
																e.preventDefault()
																deleteConcept(item.id)
															}}
														>
															<i className="bi bi-trash"></i>
														</button>
														<br></br>
														<small style={{ fontSize: "10px" }}>
															{item.hasOwnProperty("creation_time") && item.creation_time !== null
																? // new Intl.DateTimeFormat("en-US", {
																  //   year: "numeric",
																  //   month: "long",
																  //   day: "2-digit",
																  // }).format(item.creation_time.$date)

																  new Date(item.creation_time).toLocaleString("en-US", {
																		year: "numeric",
																		month: "long",
																		day: "2-digit",
																  })
																: creation_time(item.creation_time)}
														</small>
													</li>
											  ))
											: null}
									</ul>
								</div>

								{elementsPerPageSavedConcepts === 1000 ? null : (
									<div className="col-12 d-flex justify-content-center">
										{currentpageSavedConcepts === 1 ? null : (
											<button type="button" className="btn btn-primary  mr-1" onClick={prevPageSavedConcepts}>
												&laquo; Prev
											</button>
										)}
										{currentpageSavedConcepts === totalpagesSavedConcepts ||
										Number.isNaN(totalpagesSavedConcepts) ||
										totalpagesSavedConcepts === 0 ? null : (
											<button type="button" className="btn btn-primary" onClick={nextPageSavedConcepts}>
												Next &raquo;
											</button>
										)}
									</div>
								)}
							</div>
							<div className="col-12">
								<div className="col-12 d-flex">
									<p className="font-16">
										<strong>Shared concepts</strong>
									</p>
								</div>
								<div className="col-12 d-flex mb-3 mb-4 mt-3">
									<div className="col-6 divBlock d-flex justify-content-center">
										<div className="col-3 divBlock mt-1">
											<span>
												<strong>A-Z</strong>
											</span>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.alphabeticalShared === "asc" || sortConcepts.alphabeticalShared === ""
														? "bi bi-arrow-down-circle dateIcon"
														: "bi bi-arrow-down-circle-fill dateIcon"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														alphabeticalShared: "desc",
														dateShared: "",
													})
												}}
											></i>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.alphabeticalShared === "desc" || sortConcepts.alphabeticalShared === ""
														? "bi bi-arrow-up-circle dateIcon ml-2"
														: "bi bi-arrow-up-circle-fill dateIcon ml-2"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														alphabeticalShared: "asc",
														dateShared: "",
													})
												}}
											></i>
										</div>
									</div>
									<div className="col-6 divBlock d-flex justify-content-center">
										<div className="col-3 divBlock mt-1">
											<span>
												<strong>Date</strong>
											</span>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.dateShared === "asc" || sortConcepts.dateShared === ""
														? "bi bi-arrow-down-circle dateIcon"
														: "bi bi-arrow-down-circle-fill dateIcon"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														dateShared: "desc",
														alphabeticalShared: "",
													})
												}}
											></i>
										</div>
										<div className="col-1 divBlock btnArrow mt-1">
											<i
												className={
													sortConcepts.dateShared === "desc" || sortConcepts.dateShared === ""
														? "bi bi-arrow-up-circle dateIcon ml-2"
														: "bi bi-arrow-up-circle-fill dateIcon ml-2"
												}
												style={{ cursor: "pointer" }}
												onClick={(e) => {
													setSortConcepts({
														...sortConcepts,
														dateShared: "asc",
														alphabeticalShared: "",
													})
												}}
											></i>
										</div>
									</div>
								</div>
								<div className="col-12 ">
									<ul>
										{Array.isArray(filtered_share)
											? filtered_share.map((item, i) => (
													<li
														key={i}
														className={`conceptShared conceptShared_page_${Math.ceil(
															(i + 1) / elementsPerPageSharedConcepts
														)} ${
															Math.ceil((i + 1) / elementsPerPageSharedConcepts) === currentpageSharedConcepts
																? null
																: "hidePage"
														}`}
													>
														<span
															id={item.id}
															className="pointer"
															onMouseOver={(e) => {
																e.preventDefault()
																setItemId(item.id)
															}}
															onMouseOut={(e) => {
																e.preventDefault()
																setItemId("")
															}}
															style={
																item.id === itemId
																	? {
																			borderBottom: "1px solid black",
																			fontWeight: "bold",
																	  }
																	: null
															}
															onClick={(e) => {
																e.preventDefault()
																setPage((prevPage) => 1)
																loadSavedContent(item.id, item.description, item.visual.terms, item)
																//dispatch(setSelectedBuildConcept(item))
																setSearchBuildTags(item?.visual?.terms || [])
																setShowSavedList(false)
															}}
														>
															{item.description}
														</span>
														<br></br>
														<small style={{ fontSize: "10px" }}>
															{item.hasOwnProperty("creation_time") && item.creation_time !== null
																? // new Intl.DateTimeFormat("en-US", {
																  //   year: "numeric",
																  //   month: "long",
																  //   day: "2-digit",
																  // }).format(item.creation_time.$date)

																  new Date(item.creation_time).toLocaleString("en-US", {
																		year: "numeric",
																		month: "long",
																		day: "2-digit",
																  })
																: creation_time(item.creation_time)}
														</small>
													</li>
											  ))
											: null}
									</ul>
								</div>
								{elementsPerPageSharedConcepts === 1000 ? null : (
									<div className="col-12 d-flex justify-content-center">
										{currentpageSharedConcepts === 1 ? null : (
											<button type="button" className="btn btn-primary  mr-1" onClick={prevPageSharedConcepts}>
												&laquo; Prev
											</button>
										)}
										{currentpageSharedConcepts === totalpagesSharedConcepts ||
										Number.isNaN(totalpagesSharedConcepts) ||
										totalpagesSharedConcepts === 0 ? null : (
											<button type="button" className="btn btn-primary" onClick={nextPageSharedConcepts}>
												Next &raquo;
											</button>
										)}
									</div>
								)}
							</div>
						</div>
						{/* <InfoDialog btninfo="searchBuild" /> */}
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default SearchBuild
